import {
  type CustomQueryOptions,
  useGetMembersPlacesByPlaceId,
  usePrefetch,
} from "@birdwatch/client";

export const useMyPlaceDetail = (
  placeId: string,
  options?: CustomQueryOptions,
) =>
  useGetMembersPlacesByPlaceId({ placeId }).get({
    enabled: !!placeId,
    ...options,
  });

export const usePrefetchMyPlaceDetail = () => {
  const prefetch = usePrefetch();

  return async (placeId: string) => {
    await prefetch(useGetMembersPlacesByPlaceId({ placeId }));
  };
};
